import "./AboutBmf.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Values from "./sections/Values";
import Advantages from "./sections/Advantages";
import Footer from "@/reusable_sections/Footer";
export default function AboutBmfPage() {
  return <div>
      <Header />
      <Story />
      <Values />
      <Advantages />
      <Footer />
    </div>;
}